import { Component, ComponentRef, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '../../../../services/http.service';
import { NotificationService } from '../../../../services/notification.service';
import { PhysicalCreateComponent } from '../../../../_crm/physical/physical-create/physical-create.component';
import { OverlayWindowService } from '../../../../_crm/single-window/shared/overlay-window.service';
import { EntityCreateComponent } from '../../../../_crm/entity/entity-create/entity-create.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-flat-proprietors',
    templateUrl: './flat-proprietors.component.html',
    styleUrls: ['./flat-proprietors.component.scss'],
    standalone: false
})
export class FlatProprietorsComponent implements OnInit, OnDestroy {

  public data: any = null;
  public form: UntypedFormGroup;
  @Input() public flatId = null;
  public physicalSubscription: Subscription;
  public entittSubscription: Subscription;
  public api_action = 'Search.physicals_and_organisations';
  public types = {
    'no': 'Не определен',
    'sob': '1 собственник',
    'sovm': 'Совместная',
    'dol': 'Долевая',
  };
  public loading = true;

  public get sob(): UntypedFormArray {
    return this.form.get('sob') as UntypedFormArray;
  }

  public get sovm(): UntypedFormArray {
    return this.form.get('sovm') as UntypedFormArray;
  }

  public get dol(): UntypedFormArray {
    return this.form.get('dol') as UntypedFormArray;
  }

  constructor(public activeRoute: ActivatedRoute, public fb: UntypedFormBuilder, public http: HttpClient,
              public notify: NotificationService, private overlayWindowService: OverlayWindowService) {
  }

  ngOnInit() {
    if (this.flatId) {
      this.getData();
    }
  }

  getData() {
    this.http.resolvers({
      'data': this.http.post('Flat.get', {'realty_id': +this.flatId, 'tab': 'proprietors'}),
    }).then((resolvers) => {
      this.data = resolvers['data'];
      this.pathForm();
      this.loading = false;
    });
  }

  pathForm() {
    let sobArray = this.fb.array([
      this.fb.group({
        'caption': '',
        'value': ['', Validators.required],
      })
    ]);
    let sovmArray = this.fb.array([
      this.fb.group({
        'caption': '',
        'value': ['', Validators.required],
      })
    ]);
    let dolArray = this.fb.array([
      this.fb.group({
        'caption': '',
        'value': ['', Validators.required],
        'znamenatel': '',
        'chislitel': '',
      })
    ]);

    if (this.data['proprietors'].length) {
      switch (this.data['type']) {
        case 'sob':
          sobArray = this.fb.array([
            this.fb.group({
              'caption': this.data['proprietors'][0]['caption'],
              'value': [this.data['proprietors'][0]['value'], Validators.required],
            })
          ]);
          break;
        case 'sovm':
          sovmArray = this.fb.array(this.data['proprietors'].map((item) => {
            return this.fb.group({
              'caption': item['caption'],
              'value': [item['value'], Validators.required],
            });
          }));
          break;
        case 'dol':
          dolArray = this.fb.array(this.data['proprietors'].map((item) => {
            return this.fb.group({
              'caption': item['caption'],
              'value': [item['value'], Validators.required],
              'znamenatel': item['znamenatel'],
              'chislitel': item['chislitel'],
            });
          }));
          break;
      }
    }

    this.form = this.fb.group({
      'type': [(this.data['type']) ? this.data['type'] : 'no'],
      'sob': sobArray,
      'sovm': sovmArray,
      'dol': dolArray,
    });
  }

  sovmAdd() {
    this.sovm.push(
      this.fb.group({
        'caption': '',
        'value': ['', Validators.required],
      })
    );
  }

  sovmDelete(item) {
    this.sovm.removeAt(this.sovm.controls.indexOf(item));
  }

  dolAdd() {
    this.dol.push(
      this.fb.group({
        'caption': '',
        'value': ['', Validators.required],
        'znamenatel': '',
        'chislitel': '',
      })
    );
  }

  dolDelete(item) {
    this.dol.removeAt(this.dol.controls.indexOf(item));
  }

  physicalAdd() {
    this.overlayWindowService.openComponentInPopup(PhysicalCreateComponent)
      .then((factory: ComponentRef<PhysicalCreateComponent>) => {
        this.physicalSubscription = factory.instance.onCreate.subscribe((response) => this.newProprietor({
          'value': 'physical:' + response.value,
          'description': response.description,
        }));
      });
  }

  entityAdd() {
    this.overlayWindowService.openComponentInPopup(EntityCreateComponent)
      .then((factory: ComponentRef<EntityCreateComponent>) => {
        this.entittSubscription = factory.instance.onCreate.subscribe((response) => this.newProprietor({
          'value': 'organisation:' + response.value,
          'description': response.description,
        }));
      });
  }

  newProprietor(response) {
    switch (this.form.value.type) {
      case 'sob':
        this.sob.removeAt(0);
        this.sob.push(
          this.fb.group({
            'caption': response.description,
            'value': [response.value, Validators.required],
          })
        );
        break;
      case 'sovm':
        this.sovm.push(
          this.fb.group({
            'caption': response.description,
            'value': [response.value, Validators.required],
          })
        );
        break;
      case 'dol':
        this.dol.push(
          this.fb.group({
            'caption': response.description,
            'value': [response.value, Validators.required],
            'znamenatel': '',
            'chislitel': '',
          })
        );
        break;
    }
  }

  saveForm() {
    if (this.form.value.type === 'sob' && !this.sob.valid) {
      this.onError('Выберите собственника');
      return false;
    }
    if (this.form.value.type === 'sovm' && this.sovm.controls.length && !this.sovm.valid) {
      this.onError('Выберите собственников');
      return false;
    }
    if (this.form.value.type === 'dol' && this.dol.controls.length && !this.dol.valid) {
      this.onError('Выберите собственников');
      return false;
    }

    const data = {};
    data['type'] = (this.form.value.type === 'no') ? '' : this.form.value.type;
    switch (this.form.value.type) {
      case 'sob':
        data['owners'] = this.sob.value;
        break;
      case 'sovm':
        data['owners'] = this.sovm.value;
        break;
      case 'dol':
        data['owners'] = this.dol.value;
        break;
      case 'no':
        data['owners'] = [];
        break;
    }

    this.http.post('Flat.update_flat', {
      'realty_id': +this.flatId,
      'data': {
        'proprietors': data
      }
    }).subscribe(
      (response) => {
        this.onSuccess(response);
      },
      (error) => this.onError(error)
    );
  }

  onSuccess(response) {
    this.notify.notifySuccess('Поздравляем', 'Данные успешно сохранены', 3000);
  }

  onError(error) {
    this.notify.notifyError('Ошибка', error, 5000);
  }

  ngOnDestroy() {
    if (this.physicalSubscription) {
      this.physicalSubscription.unsubscribe();
    }
    if (this.entittSubscription) {
      this.entittSubscription.unsubscribe();
    }
  }

}
